

















































































































































































































import {
  defineComponent,
  onMounted,
  reactive,
  toRefs,
} from '@vue/composition-api';
import Pagination from '@/components/Pagination';
import Box from '@/components/Box/index.vue';
import Cloumns from '@/components/Cloumns/index.vue';
import Steps from '@/components/Steps/index';
import request from '@/utils/request';
import addComma from '@/utils/addComma';
import { Message } from 'element-ui';

export default defineComponent({
  name: 'financingDetail',
  setup(props: any, { root }) {
    const state: any = reactive({
      stepArray: [
        { top: '第一步', bottom: '提交申请' },
        { top: '第二步', bottom: '银行融资受理' },
        { top: '第三步', bottom: '银行放款' },
      ],
      stepsActive: '1',
      dialogVisible: false,
      paymentOrderConfig: {
        column: [
          { key: 'serial', label: '序号', custom: true, width: 50 },
          { key: 'payCorpName', label: '付款企业' },
          { key: 'supplierName', label: '收款企业' },
          { key: 'orderNo', label: '付款单号', width: 210 },
          {
            key: 'amount',
            label: '付款金额',
            width: 130,
            custom: true,
            align: 'right',
            headerAlign: 'right',
          },
          { key: 'currency', label: '币种', width: 70 },
          { key: 'orderTypeName', label: '付款单类型' },
          { key: 'orderStatusName', label: '付款单状态', width: 110 },
          { key: 'planPayTime', label: '预计付款日期', width: 110 },
        ],
        data: [],
      },
      scfInvoiceConfig: {
        column: [
          { key: 'invoiceType', label: '发票类型' },
          { key: 'invoiceSign', label: '发票子类型', width: 130 },
          { key: 'invoiceNo', label: '发票号码', width: 210 },
          { key: 'invoiceCode', label: '发票代码', width: 210 },
          {
            key: 'invoiceAmount',
            label: '发票金额',
            width: 130,
            custom: true,
            align: 'right',
            headerAlign: 'right',
          },
          {
            key: 'taxAmount',
            label: '税额',
            width: 130,
            custom: true,
            align: 'right',
            headerAlign: 'right',
          },
          { key: 'checkCode', label: '校验码', width: 70 },
          { key: 'invoiceDate', label: '发票日期', width: 120 },
        ],
        data: [],
      },
      page: 1,
      pageSize: 5,
      total: 0,
      orderNo: '',
      attrConfig: {
        column: [
          { key: 'serial', label: '序号', custom: true, width: 50 },
          { key: 'fileName', label: '附件名称' },
          { key: 'fileSize', label: '附件大小', custom: true },
          { key: 'uploadTime', label: '上传日期' },
          { key: 'createBy', label: '上传人' },
          { key: 'c', label: '操作', operate: true },
        ],
        data: [],
      },
      noteConfig: {
        column: [
          { key: 'serial', label: '序号', custom: true, width: 50 },
          { key: 'commentCorpName', label: '备注方' },
          { key: 'commentPerson', label: '备注人' },
          { key: 'comment', label: '备注内容' },
          { key: 'commentTime', label: '备注时间' },
        ],
        data: [],
      },
      histryConfig: {
        column: [
          { key: 'serial', label: '序号', custom: true, width: 50 },
          { key: 'companyName', label: '处理方' },
          { key: 'operator', label: '处理人' },
          { key: 'operateStep', label: '处理步骤' },
          { key: 'operateAction', label: '处理意见', custom: true },
          { key: 'operateTime', label: '处理时间' },
          { key: 'nextStepName', label: '下个处理节点', custom: true },
        ],
        data: [],
      },
      basicInfo: [],
      blockchainInfo: [],
      auth: true,
      gotoBankBtn: null,
      banckInfo: null,
      dialogBlockchainVisible: false,
    });

    const getData = async () => {
      const parms = {
        financeOrderApplyId: [root.$route.params.financeOrderApplyId],
      };
      const result = await request('financing', 'financingDetail', parms);
      if (result.code === 2000) {
        const [
          {
            financeOrderUndo,
            financeOrderFile,
            financeOrderComment,
            financeOrderApply,
            financeOrderLog,
            financeOrderBlockchain,
          },
        ] = result.data;
        state.orderNo = financeOrderUndo.orderNo;
        getInvoice();
        const {
          applyNo,
          supplierName,
          amount,
          applyAmount,
          bankName,
          applyDays,
          applyPersonName,
          applyStatus,
          applyStatusName,
          bankCode,
          cmisId,
          redirectUrl,
        } = financeOrderApply;

        state.basicInfo = [
          { title: '融资申请单号', value: applyNo },
          { title: '融资企业名称', value: supplierName },
          { title: '可融资金额', value: `${addComma(amount)} CNY` },
          { title: '本次融资金额', value: `${addComma(applyAmount)} CNY` },
          { title: '融资银行', value: bankName },
          { title: '融资天数', value: `${applyDays}天` },
          { title: '申请人', value: applyPersonName },
          {
            title: '融资申请单状态',
            value: applyStatusName,
            textColor: applyStatus === '6' ? '#3a84fb' : '',
          },
        ];
        state.banckInfo = {
          bankCode,
          cmisId,
          redirectUrl,
        };
        state.financeOrderApply = financeOrderApply;
        state.paymentOrderConfig.data = financeOrderUndo && [financeOrderUndo];
        state.attrConfig.data = financeOrderFile;
        state.noteConfig.data = financeOrderComment && [financeOrderComment];
        state.histryConfig.data = financeOrderLog;
        state.stepsActive =
          financeOrderApply.financeNode === '4' ||
          financeOrderApply.financeNode === '5'
            ? '2'
            : financeOrderApply.financeNode;
        state.blockchainInfo = [
          { title: '区块链网络ID', value: financeOrderBlockchain?.clusterId },
          { title: '合约名称', value: financeOrderBlockchain?.chaincodeName },
          { title: '通道名称', value: financeOrderBlockchain?.channelName },
          { title: '节点列表', value: financeOrderBlockchain?.peersN },
          {
            title: '创建交易的组织名',
            value: financeOrderBlockchain?.createOrgName,
          },
          { title: '交易所在区块号', value: financeOrderBlockchain?.blockId },
          {
            title: '交易所在区块高度',
            value: financeOrderBlockchain?.blockHeight,
          },
          {
            title: '交易所在区块哈希',
            value: financeOrderBlockchain?.blockHash,
          },
          { title: '交易数据', value: financeOrderBlockchain?.transactionData },
          {
            title: '交易状态',
            value: financeOrderBlockchain?.transactionStatus,
          },
          { title: '交易ID', value: financeOrderBlockchain?.transactionId },
          { title: '交易hash', value: financeOrderBlockchain?.transactionHash },
          {
            title: '交易创建时间',
            value: financeOrderBlockchain?.transactionCreateTime,
          },
        ];
        // 添加待确认状态
        state.gotoBankBtn = applyStatus === '6' ? '前往银行确认' : null;
      }
    };
    const pageChange = (newPage, newSize) => {
      state.page = newPage;
      state.pageSize = newSize;
      getInvoice();
    };

    const getInvoice = async () => {
      const parmsForInvoice = {
        current: state.page,
        size: state.pageSize,
        applyNo: state.orderNo,
      };
      const resultForInvoice = await request(
        'financing',
        'scfInvoiceList',
        parmsForInvoice,
      );
      if (resultForInvoice.code === 2000) {
        state.scfInvoiceConfig.data = resultForInvoice.data.dataList;
        state.total = resultForInvoice.data.total;
      }
    };
    // 下载附件
    const downFile = async (row) => {
      const parms = {
        financeOrderFileId: row.financeOrderFileId,
      };
      await request('financing', 'financingFileDownload', parms);
    };

    // 前往银行确认
    const gotoBankConfirm = () => {
      state.dialogVisible = false;

      if (!!state.banckInfo.redirectUrl) {
        // 招商银行发送请求，其他银行直接跳转
        if (state.banckInfo.bankCode === 'CMB') {
          const routeUrl = root.$router.resolve({
            path: '/financing/confirm',
            query: {
              data: JSON.stringify(state.banckInfo),
            },
          });
          window.open(routeUrl.href, '_blank');
        } else {
          window.open(state.banckInfo.redirectUrl);
        }
      } else {
        Message.error('系统异常，请稍后重试或联系平台方协助解决。');
      }
    };

    onMounted(getData);

    return {
      ...toRefs(state),
      downFile,
      gotoBankConfirm,
      addComma,
      pageChange,
    };
  },

  components: {
    Pagination,
    Box,
    Cloumns,
    Steps,
  },
});
